<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="12">
              <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
                {{ $t('tanaoroshiProductCodeList.label.siteCode') }}: {{ productInfo.siteCode }}
              </v-chip>
              <v-chip dark class="mr-4 mb-4 bg-indigo-darken-1">
                {{ $t('tanaoroshiProductCodeList.label.siteName') }}: {{ productInfo.siteName }}
              </v-chip>
            </v-col>
          </v-row>
          <v-form @submit.prevent="search" ref="formRefs">
            <v-row>
              <v-col cols="3">
                <v-select density="compact" variant="outlined" hide-details="auto" :items="zoneItems"
                  :label="$t('tanaoroshiProductCodeList.label.zoneName')" item-title="name" item-value="code"
                  v-model="searchCondition.zoneName" clearable />
              </v-col>
              <v-col cols="3">
                <v-select density="compact" variant="outlined" hide-details="auto" :items="[
                  { 'key': 1, 'label': $t('tanaoroshiProductCodeList.label.little') },
                  { 'key': 2, 'label': $t('tanaoroshiProductCodeList.label.excess') },
                  { 'key': 3, 'label': $t('tanaoroshiProductCodeList.label.matched') },
                ]" :label="$t('tanaoroshiProductCodeList.label.difference')" item-title="label" item-value="key"
                  v-model="searchCondition.filterLoss" clearable />
              </v-col>
              <v-col cols="3">
                <v-text-field density="compact" variant="outlined" hide-details="auto"
                  v-model="searchCondition.brandName" :label="$t('tanaoroshiProductCodeList.label.brandName')" />
              </v-col>
              <v-col cols="3">
                <v-text-field density="compact" variant="outlined" hide-details="auto"
                  v-model="searchCondition.productCode" :label="$t('tanaoroshiProductCodeList.label.productCode')" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-switch v-model="showZeroInventory" color="blue" inset
                  :label="$t('tanaoroshiProductCodeList.label.showZeroInventory')"></v-switch>
              </v-col>
            </v-row>
          </v-form>

          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <th v-for="header in headers" :key="header" @click.stop="tableSort(header)"
                      :style="cursorCheck(header)">
                      {{ $t("tanaoroshiProductCodeList.label.table." + header) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in filteredDataList" :key="data.productCode" @click="rowClick(data)"
                    :style="cursorCheck(null)">
                    <td v-for="header in headers" :key="header">{{ data[header] }}</td>
                  </tr>
                  <tr>
                    <td :colspan="headers.length"></td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-pagination v-model="currentPageNo" :length="maxPageNo" />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select density="compact" variant="outlined" hide-details="auto" v-model="displayPerPage"
                    :items="displayPerPageItem" item-title="name" item-value="value"
                    :label="$t('common.label.displayCountPerPage')" @update:modelValue="resetCondition()"
                    return-object />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  {{ displayContentNo.minNo }} - {{ displayContentNo.maxNo }}{{ $t('common.label.displayedDataRange') }}
                  /
                  {{ sortedTable.length }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn dark class="px-8 bg-indigo-darken-1" elevation="2" @click="downloadCsv"
                :disabled="sortedTable.length == 0">{{ $t('common.action.outputCsv') }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <ErrorDialog v-if="dataError" :URL="previousURL" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import Vue from "vue";
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import store from "@/store";
import utils from "@/utils";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import ErrorDialog from "@/components/dialog/ErrorDialog";

export default {
  components: { AppWrapperView, ErrorDialog },
  props: {},
  computed: {
    // 表示範囲計算
    displayContentNo() {
      const minNo = this.sortedTable.length != 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
      const maxNo = this.displayPerPage.value * (this.currentPageNo);
      if (maxNo > this.sortedTable.length || this.displayPerPage.value == 0) {
        return { minNo: minNo, maxNo: this.sortedTable.length };
      }
      return { minNo: minNo, maxNo: maxNo };
    },

    // 最大ページ数計算
    maxPageNo() {
      if (this.displayPerPage.value == 0) return 0;
      return Math.ceil(this.sortedTable.length / this.displayPerPage.value);
    },

    // ソート処理
    sortedTable() {
      let tempArray = this.dataList.map(x => x);
      if (this.sortState.target != "") {
        // 昇順
        if (this.sortState.ascent) tempArray = tempArray.sort((a, b) => {
          if (a[this.sortState.target] > b[this.sortState.target]) {
            return 1;
          }
          if (a[this.sortState.target] < b[this.sortState.target]) {
            return -1;
          }
          return 0;
        })
        // 降順
        else tempArray = tempArray.sort((a, b) => {
          if (a[this.sortState.target] > b[this.sortState.target]) {
            return -1;
          }
          if (a[this.sortState.target] < b[this.sortState.target]) {
            return 1;
          }
          return 0;
        })
      }

      // フィルター処理
      // ゾーン名
      if (this.searchCondition.zoneName != null && this.searchCondition.zoneName != "") {
        tempArray = tempArray.filter(x =>
          x.zoneName && x.zoneName === this.searchCondition.zoneName
        );
      }

      // 差異
      if (this.searchCondition.filterLoss != null) {
        if (this.searchCondition.filterLoss == 1) {
          // 過少（予定 > 実績）
          tempArray = tempArray.filter(x => x.plannedStock > x.actualStock);
        } else if (this.searchCondition.filterLoss == 2) {
          // 過剰（予定 < 実績）
          tempArray = tempArray.filter(x => x.plannedStock < x.actualStock);
        } else if (this.searchCondition.filterLoss == 3) {
          // 一致（予定 = 実績）
          tempArray = tempArray.filter(x => x.plannedStock == x.actualStock);
        }
      }

      // ブランド名
      if (this.searchCondition.brandName != "") {
        tempArray = tempArray.filter(x =>
          x.brandName && x.brandName.toLowerCase().includes(this.searchCondition.brandName.toLowerCase())
        );
      }

      // 品番
      if (this.searchCondition.productCode != "") {
        tempArray = tempArray.filter(x =>
          x.productCode && x.productCode.toLowerCase().includes(this.searchCondition.productCode.toLowerCase())
        );
      }

      // 0件データ非表示
      if (!this.showZeroInventory) {
        tempArray = tempArray.filter(x => x.plannedStock != 0 || x.actualStock != 0);
      }

      return tempArray;
    },

    // ページング処理
    filteredDataList() {
      return this.sortedTable.slice(this.displayContentNo.minNo - 1, this.displayContentNo.maxNo);
    },

    // テーブルヘッダー定義
    headers() {
      return this.$getTableDef("TanaoroshiProductCodeListPage");
    }
  },

  data: () => ({
    currentPageNo: 1,
    dataError: false,

    // １ページ表示数
    displayPerPage: {},
    displayPerPageItem: [],

    // ソートの状態
    sortState: { target: "", ascent: true },

    // 商品情報
    productInfo: {
      siteCode: "",
      siteName: ""
    },

    // 検索条件
    searchCondition: {
      zoneName: null,
      filterLoss: null,
      brandName: "",
      productCode: "",
      colorCode: "",
      sizeCode: "",
    },

    // データリスト
    dataList: [],
    // ゾーンリスト
    zoneItems: [],
    // 0件データ表示切替
    showZeroInventory: false,

    // エラー時の遷移先
    previousURL: Paths.TANAOROSHI_LIST,
  }),

  methods: {
    // カーソルの変更
    cursorCheck(value) {
      return "cursor: pointer;";
    },

    // テーブルの条件リセット
    resetCondition() {
      // １ページ目
      this.currentPageNo = 1;
      // ソートなし
      this.sortState.target = "";
      this.sortState.ascent = true;
    },

    // テーブルソート
    tableSort(headValue) {
      if (headValue == "no") return;
      this.currentPageNo = 1;
      if (this.sortState.target == headValue) {
        this.sortState.ascent = !this.sortState.ascent;
      }
      else {
        this.sortState.target = headValue;
        this.sortState.ascent = true;
      }
    },

    // ゾーン選択肢を生成
    generateZoneItems() {
      // データリストからユニークなゾーン名を取得
      const uniqueZones = [...new Set(this.dataList.map(item => item.zoneName))];
      this.zoneItems = uniqueZones
        .map(zone => ({
          code: zone,
          name: zone
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },

    // 行クリック時の処理
    rowClick(item) {
      // 棚卸オブジェクトにデータを保存
      const existingData = store.getTanaoroshi();
      const tanaoroshiData = {
        ...existingData,  // 既存データ
        productCode: item.productCode,
        zoneName: item.zoneName,
        zoneCode: item.zoneCode,
      };
      // ストアに棚卸情報を保存
      store.setTanaoroshi(tanaoroshiData);

      // SKU一覧ページへ遷移
      router.push({ path: '/tanaoroshiList/productCode/sku' });
    },

    // API検索処理
    search() {
      const tanaoroshiData = store.getTanaoroshi();

      api.post("/tanaoroshi/search-product-code", {
        inventoryNo: tanaoroshiData.inventoryNo
      })
        .then((response) => {
          // データが0件の場合はエラー画面表示
          if (!(response.data.results?.productCodeList?.length ?? 0 > 0)) {
            this.dataError = true;
            return;
          }

          // レスポンスからデータを取得
          const productCodeList = response.data.results?.productCodeList ?? [];

          // 店舗名を設定（最初のデータから取得）
          if (productCodeList.length > 0) {
            this.productInfo.siteName = productCodeList[0].siteName;
          }

          // データリストを更新
          this.dataList.splice(0, this.dataList.length, ...productCodeList.map(item => ({
            siteCode: item.siteCode,
            siteName: item.siteName,
            brandName: item.brandName,
            productCode: item.productCode,
            erpStock: item.erpStock,
            plannedStock: item.plannedStock,
            actualStock: item.actualStock,
            differenceStock: item.differenceStock,
            zoneCode: item.zoneCode,
            zoneName: item.zoneName
          })));
          this.generateZoneItems();
        })
        .catch((error) => {
          //do nothing
        });
    },

    // CSVダウンロード
    downloadCsv() {
      utils.simpleDownloadCsv(this.headers, this.sortedTable, "tanaoroshiProductCodeList.label.table.", 'tanaoroshiProductCodeList.fileNamePrefix.csv', this.$t);
    },
  },

  created() {
    // do nothing
  },

  mounted() {
    this.displayPerPage = utils.getDisplayPerPage(this.$t);
    this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);

    // ストアから棚卸情報を取得
    const tanaoroshiData = store.getTanaoroshi();
    if (!tanaoroshiData || !tanaoroshiData.inventoryNo) {
      this.dataError = true;
    } else {
      this.productInfo.siteCode = tanaoroshiData.siteCode;
      this.productInfo.siteName = tanaoroshiData.siteName;
      this.search();
    }
  },
};
</script>

<style></style>